import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhqs';
import { ResultState } from '@rootCommon/types/common';
import { SiteFhq } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type FhqSitesState = ResultState<SiteFhq[] | null>;

const initState: FhqSitesState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqsReducer = (state = initState, action: Action): FhqSitesState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqs.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchFhqs.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchFhqs.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateFhqs.request):
      return { ...state, loading: true, error: null };
    case getType(actions.updateFhqs.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateFhqs.failure):
      return { ...state, loading: false, error: action.payload };

    case getType(actions.setFhqsIsLoading):
      return { ...state, loading: true };

    default:
      return state;
  }
};

export default fhqsReducer;
